import React, { Component } from "react";
import "./assets/css/TemplateDesign.css";
import {
  BsFonts,
} from 'react-icons/bs';

export default class LeftTextFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customs: props.myProps,
    };
  }

  onTrigger = (event) => {
    this.props.parentCallback();
    event.preventDefault();
  };

  render() {
    return (
      <div className="template-fill-menu-item">
        <button
          className="menu-item-btn"
          value="Add Custom Text"
          onClick={this.onTrigger}
        >
          <div className='menu-item'>
            <span className='icon'><BsFonts /></span>
            <span className='name'>Add Text</span>
          </div>
        </button>
      </div>
    );
  }
}
